import axios from '../../../utils/axios';
import { CONFIG } from '../../../config';

export type B2bCompanyOption = { id: string; name: string };

export const getCompanies = async (): Promise<B2bCompanyOption[]> => {
  const response = await axios.get<B2bCompanyOption[]>(
    `${CONFIG.SERVICES_ADMIN_URL}/api/v1/admin/b2b/companies/list`
  );
  return response.data;
};
